import { useEffect, useState } from 'react';
import axios from 'axios';
import API_ENDPOINTS, { getImageUrl } from '../../config/api';
import {
  buildFontFaceCss,
  buildTypographyCssVars,
  resolveFontAssignments,
} from '../../utils/siteFonts';

/**
 * Injects uploaded @font-face rules and CSS variables for public typography.
 */
function SiteTypography({ settings }) {
  const [customFonts, setCustomFonts] = useState([]);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(API_ENDPOINTS.GET_FONTS)
      .then((res) => {
        if (!cancelled && res.data?.success) {
          setCustomFonts(res.data.fonts || []);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const styleId = 'site-typography-styles';
    let el = document.getElementById(styleId);
    if (!el) {
      el = document.createElement('style');
      el.id = styleId;
      document.head.appendChild(el);
    }

    const faces = buildFontFaceCss(customFonts, getImageUrl);
    const vars = buildTypographyCssVars(settings);
    const assignments = resolveFontAssignments(settings);

    el.textContent = `${faces}

:root {
  ${vars}
}

/* 1. Body Text */
body, p, .features-section-text, .guest-message-body, .timeline-content p {
  font-family: ${assignments.font_body_text};
}

/* 2. Headings (General/Section) */
h1, h2, h3, h4, h5, h6, .section-header h2, .features-section-title, .guest-message-title, .timeline-content h4 {
  font-family: ${assignments.font_section_heading};
}

/* 3. Hero Couple Names */
.hero-couple-names, .hero-couple-names--bargiery {
  font-family: ${assignments.font_hero_heading} !important;
}

/* 4. Hero Date & Countdown */
.hero-date-static, .countdown-subtitle, .countdown-timer, .countdown-timer .timer-segment .timer-value {
  font-family: ${assignments.font_hero_body} !important;
}

/* 5. Navigation menu buttons */
.navbar .nav-links button, .navbar .nav-link-quiet, .mobile-nav button {
  font-family: ${assignments.font_navigation} !important;
}

/* 6. Buttons */
button, .btn-primary, .btn-outline-small, .submit-reservation-btn, .directions-btn, .nav-cta, .nav-cta-mobile {
  font-family: ${assignments.font_button} !important;
}

/* 7. Modal Headings */
.modal-overlay h1, .modal-overlay h2, .modal-overlay h3, .modal-overlay h4, .modal-overlay h5, .modal-overlay h6,
.modal-content h1, .modal-content h2, .modal-content h3, .modal-content h4, .modal-content h5, .modal-content h6,
.modal-header-modern h1, .modal-header-modern h2, .modal-header-modern h3,
.program-day-header h3, .program-day-header h4, .accommodation-modal h3,
.venue-hero h3, .cash-gift-card h4, .gift-info h4, .pledge-page h1, .pledge-page h2, .pledge-page h3, .pledge-page h4 {
  font-family: ${assignments.font_modal_heading} !important;
}

/* 8. Modal Body Text */
.modal-overlay, .modal-overlay p, .modal-overlay span, .modal-overlay div, .modal-overlay label, .modal-overlay input, .modal-overlay textarea, .modal-overlay select,
.modal-content, .modal-content p, .modal-content span, .modal-content div, .modal-content label, .modal-content input, .modal-content textarea, .modal-content select,
.modal-body-modern, .gifts-modal, .venue-modal, .program-modal, .accommodation-modal,
.gifts-modal p, .venue-modal p, .program-modal p, .accommodation-modal p,
.pledge-page, .pledge-page p, .pledge-page div, .pledge-page span, .pledge-page label, .pledge-page input {
  font-family: ${assignments.font_modal_body} !important;
}`;
  }, [settings, customFonts]);

  return null;
}

export default SiteTypography;
